<template>
  <v-container fluid>
    <div id="okta-login-container" />
  </v-container>
</template>

<script setup>
import OktaSignIn from '@okta/okta-signin-widget';
import { nextTick, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useContextStore } from '@/stores/context';

const context = useContextStore();
const router = useRouter();
const route = useRoute();
// This should be defined in config
const oktaBaseUrl = 'https://owlabs.okta.com';

let widget = null;

onMounted(async () => {
  await nextTick();
  widget = new OktaSignIn({
    baseUrl: oktaBaseUrl,
    clientId: context.oktaClientId,
    redirectUri: context.loginRedirectUrl,
    useClassicEngine: true,
    authParams: {
      oktaBaseUrl,
      issuer: oktaBaseUrl,
      pkce: false,
      responseType: 'id_token',
      scopes: ['openid', 'email', 'profile'],
    },
  });
  widget.renderEl(
    { el: '#okta-login-container' },
    res => {
      if (res.status === 'SUCCESS') {
        let returnPath = route.query.returnPath || '/';
        if (returnPath === '/ow-auth/login') returnPath = '/';
        // Post the token back to our backend to generate JWT token
        // TODO upgrade away from implicit flow to use authorization code flow
        context.loginOkta(res.tokens.idToken.idToken).then(() => {
          router.push(returnPath);
        });
      }
    },
    err => {
      throw err;
    }
  );
});

onUnmounted(() => {
  // Remove the widget from the DOM on path change
  widget.remove();
});
</script>
